import { baseURL } from "./_common";

// HEADERS
export default [
  {
    // HEADER 1 - SWIPE SLIDER
    id: 201,
    type: "header",
    title: "Swipe Slider Header",
    template: "block-header1",
    hasScript: true,
    firebase: false,
    required: [{ title: "swiper", js: "swiper.js", css: "swiper.css" }],
    options: {
      fullHeight: true,
      scrollNext: { enabled: true, text: "LEARN MORE" },
      pagination: "arrows",
      slides: [
        {
          id: 1,
          bg: {
            url: `${baseURL}/static/templates/theme1/img/bg/01.jpg`,
            color: "transparent"
          },
          title: { text: "A theme with personality", color: "#ffffff" },
          subtitle: {
            text:
              "This is a powerful theme with some great features that you can use in your future projects.",
            color: "rgba(255, 255, 255, 0.8)"
          },
          align: "left",
          buttons: [
            {
              id: 1,
              href: "#",
              target: "_self",
              text: "Get Started Now",
              type: "primary"
            }
          ]
        },
        {
          id: 2,
          bg: {
            url: `${baseURL}/static/templates/theme1/img/bg/02.jpg`,
            color: "red"
          },
          title: { text: "A theme with diversity", color: "#ffffff" },
          subtitle: {
            text: "All the texts are editable.",
            color: "rgba(255, 255, 255, 0.8)"
          },
          align: "right",
          buttons: [
            {
              id: 1,
              href: "#",
              target: "_self",
              text: "Read More",
              type: "primary"
            }
          ]
        }
      ]
    },
    settings: [
      { el: "fullHeight", title: "Full Height", type: "toggle" },
      { el: "scrollNext.enabled", title: "Scroll down", type: "toggle" },
      { el: "scrollNext.text", title: "Scroll down Text", type: "input" },
      {
        el: "pagination",
        title: "Pagination",
        type: "select",
        options: [
          { text: "Arrows", value: "arrows" },
          { text: "Bottom dots", value: "bdots" }
        ]
      },
      {
        el: "slides",
        title: "Slides",
        type: "array",
        children: [
          { el: "bg", title: "Background URL", type: "image" },
          { el: "bg.color", title: "Background Color", type: "color" },
          { el: "title.text", title: "Title Text", type: "input" },
          { el: "title.color", title: "Title Color", type: "color" },
          { el: "subtitle.text", title: "Subtitle Text", type: "input" },
          { el: "subtitle.color", title: "Subtitle Color", type: "color" },
          {
            el: "align",
            title: "Align",
            type: "select",
            options: [
              { text: "Left", value: "left" },
              { text: "Center", value: "center" },
              { text: "Right", value: "right" }
            ]
          },
          {
            el: "buttons",
            title: "Buttons",
            type: "array",
            children: [
              { el: "href", title: "Button href", type: "input" },
              { el: "text", title: "Button text", type: "input" },
              {
                el: "type",
                title: "Button type",
                type: "select",
                options: [
                  { text: "Primary", value: "primary" },
                  { text: "Secondary", value: "secondary" },
                  { text: "Accent", value: "accent" }
                ]
              },
              {
                el: "target",
                title: "Button target",
                type: "select",
                options: [
                  { text: "Same Window", value: "_self" },
                  { text: "New Tab", value: "_blank" },
                  { text: "Top Window (for iframes)", value: "_top" }
                ]
              }
            ]
          }
        ]
      }
    ]
  }, // /HEADER 1 - SWIPE SLIDER
  {
    // HEADER 2 - DATE
    id: 202,
    type: "header",
    title: "Event - Video Header",
    template: "block-header2",
    hasScript: false,
    firebase: false,
    required: [
      {
        title: "magnific-popup",
        js: "magnific-popup.js",
        css: "magnific-popup.css"
      }
    ],
    options: {
      fullHeight: true,
      scrollNext: { enabled: true, text: "LEARN MORE" },
      bg: {
        url: `${baseURL}/static/templates/theme1/img/bg/09.jpg`,
        color: "transparent"
      },
      title: {
        text: "The New York<br>Event. Cortexial App.",
        color: "#ffffff"
      },
      subtitle: {
        text:
          "The time has come to bring those ideas and plans to life. This is where we really begin to visualize your napkin sketches and make them into beautiful pixels.",
        color: "rgba(255, 255, 255, 0.8)"
      },
      date: {
        dayText: "21",
        dayColor: "#c54041",
        monthText: "Dec",
        monthColor: "rgba(255, 255, 255, 0.5)",
        yearText: "2017",
        yearColor: "rgba(255, 255, 255, 0.5)"
      },
      align: "left",
      vidButton: {
        href: "https://www.youtube.com/watch?v=TJ1SDXbij8Y",
        title: "Intro Video",
        text: "Watch the Overview",
        type: "primary"
      }
    },
    settings: [
      { el: "fullHeight", title: "Full Height", type: "toggle" },
      { el: "scrollNext.enabled", title: "Scroll down", type: "toggle" },
      { el: "scrollNext.text", title: "Scroll down Text", type: "input" },
      { el: "bg", title: "Background URL", type: "image" },
      { el: "bg.color", title: "Background Color", type: "color" },
      // { el: "title.text", title: "Title Text", type: "input" },
      { el: "title.color", title: "Title Color", type: "color" },
      // { el: "subtitle.text", title: "Subtitle Text", type: "input" },
      { el: "subtitle.color", title: "Subtitle Color", type: "color" },
      // { el: "date.dayText", title: "Date Day", type: "input" },
      { el: "date.dayColor", title: "Date Day Color", type: "color" },
      // { el: "date.monthText", title: "Date Month", type: "input" },
      { el: "date.monthColor", title: "Date Month Color", type: "color" },
      // { el: "date.yearText", title: "Date Year", type: "input" },
      { el: "date.yearColor", title: "Date Year Color", type: "color" },
      {
        el: "vidButton.href",
        title: "Video Button Youtube URL",
        type: "input"
      },
      { el: "vidButton.title", title: "Video Button Title", type: "input" },
      { el: "vidButton.text", title: "Video Button Text", type: "input" },
      {
        el: "vidButton.type",
        title: "Video Button Type",
        type: "select",
        options: [
          { text: "Primary", value: "primary" },
          { text: "Secondary", value: "secondary" },
          { text: "Accent", value: "accent" }
        ]
      }
    ]
  } // HEADER 2 - DATE
];



// WEBPACK FOOTER //
// ./src/util/blockTemplatesHeader.js